export default __webpack_public_path__ + "static/media/socialLife.9285dae7.jpeg";